import { baseTheme } from './theme'
import { createMediaQuery } from 'styles'

export const cssVar = (variableName: string, fallback?: string) =>
  `var(${[variableName, fallback].filter(Boolean).join(', ')})`

export const cssCalc = (...expression: Array<string | number>) =>
  `calc(${expression.join(' ')})`

const defineCSSVar = (
  varName: string,
  { initial, med, lg }: { initial: string; med?: string; lg?: string }
) => `
${rootVar(varName, initial)}
${med && mediaQueryVar(baseTheme.breakpoints.med, varName, med)}
${lg && mediaQueryVar(baseTheme.breakpoints.lg, varName, lg)}
`

const mediaQueryVar = (size: string, varName: string, value: string) => `
  ${createMediaQuery(size)} {
    ${rootVar(varName, value)}
  }
`

const rootVar = (varName: string, value: string) => `
:root {
${varName}: ${value}
}
`

export const HEADER_HEIGHT_VAR = '--headerHeight'

const headerVars = defineCSSVar(HEADER_HEIGHT_VAR, {
  initial: '40px',
  med: '48px',
  lg: '56px',
})

export const VARIANT_PADDING_TOP_VAR = '--variantPaddingTop'

const variantPaddingTopVars = defineCSSVar(VARIANT_PADDING_TOP_VAR, {
  initial: '48px',
  med: '56px',
  lg: '64px',
})

const variables = `
  ${headerVars}
  ${variantPaddingTopVars}
`

export default variables
